import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";

const legalFormsAtom = atom([]);

const useLegalForms = () => {
  const [legalForms, setLegalForms] = useAtom(legalFormsAtom);

  const getLegalForms = () => {
    dataService.get(`constants/formes-juridiques`, (data) => {
      setLegalForms(
        (data || []).map(({ id, libelle, code }) => ({
          id,
          name: libelle,
          modulrId: code,
        })),
      );
    });
  };

  return {
    legalForms,
    legalFormsActions: {
      getLegalForms,
    },
  };
};

export default useLegalForms;
